import React from "react";
import { Link } from "gatsby";
import { Disclosure } from "@headlessui/react";
import { ChevronUpIcon } from "@heroicons/react/20/solid";
import { useWhoWeAreImage } from "../../../hooks/images/use-Who-We-Are";
import { GatsbyImage, getImage } from "gatsby-plugin-image";
import ReactMarkdown from "react-markdown";
import { InterLinking } from "../../utils/Interlinking/interLinking";
import { Markdown } from "../../../utils/Markdown";
const WhoWeAre = ({ data, heading }) => {
	const image = useWhoWeAreImage();

	const first = data[0];
	const second = data.slice(1, 5);
	return (
		<>
			<section className="mt-20 mx-auto  max-w-screen-xl items-center mb-20 justify-between px-4">
				<h3 className="text-3xl mb-10  text-blue-500 text-center pb-4  border-b-2">
					{heading ? `${heading}` : "Who We Are"}
				</h3>
				<div className=" grid grid-cols-1 md:grid-cols-12 gap-6">
					<div className="col-span-1  flex md:col-span-8 bg-gray-100 shadow rounded-md p-4 outline outline-offset-[4px] hover:outline-offset-[0px]  outline-slate-300/10 hover:outline-slate-800/40 duration-300">
						<div className="relative w-2/6 my-auto hidden lg:block">
							<div className="rounded-md outline outline-offset-[4px] hover:outline-offset-[0px]  outline-blue-500/30 hover:outline-blue-500/60 duration-300">
								<GatsbyImage
									image={getImage(image.childImageSharp)}
									className="object-cover w-full h-[690px] rounded-md"
									placeholder="blurred"
									alt={"related_service"}
								/>
								<Link
									to="/about"
									className="absolute text-white rounded bg-blue-500/90 outline outline-[2px] outline-offset-4 hover:outline-offset-0 hover:bg-blue-700/50 duration-100 p-3   top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2"
								>
									About Us
								</Link>
							</div>
						</div>

						<div className="pl-0 p-2 pr-0 lg:pl-6 lg:pr-2  my-auto w-full lg:w-4/6    ">
							<Markdown Output={first} replaceH1={true} />
						</div>
					</div>

					<div className="col-span-1 md:col-span-4 ">
						<div className="w-full ">
							<div className=" w-full  rounded-2xl bg-white  ">
								{second.map((item, i) => {
									if (i === 0) {
										return (
											<Disclosure defaultOpen>
												{({ open }) => (
													<>
														<Disclosure.Button className="flex w-full justify-between shadow rounded bg-blue-100 px-4 py-2 text-left text-sm font-medium text-blue-900 hover:bg-blue-200 duration-300 ">
															<Markdown
																Output={item}
																ignoreOthers={true}
																replaceH1={true}
															/>

															<ChevronUpIcon
																className={`${
																	open ? "rotate-180 transform" : ""
																} h-5 w-5 text-blue-500`}
															/>
														</Disclosure.Button>
														<Disclosure.Panel className="px-4 pt-4 pb-2 text-sm tracking-wide text-gray-900">
															<Markdown
																Output={item}
																ignoreHeadings={true}
																replaceH1={true}
															/>
														</Disclosure.Panel>
													</>
												)}
											</Disclosure>
										);
									} else {
										return (
											<Disclosure as="div" className="mt-2">
												{({ open }) => (
													<>
														<Disclosure.Button className="flex w-full justify-between rounded shadow bg-blue-100 px-4 py-2 text-left text-sm font-medium text-blue-900 hover:bg-blue-200 duration-300 ">
															<span>
																<Markdown
																	Output={item}
																	ignoreOthers={true}
																	replaceH1={true}
																/>
															</span>
															<ChevronUpIcon
																className={`${
																	open ? "rotate-180 transform" : ""
																} h-5 w-5 text-blue-500`}
															/>
														</Disclosure.Button>
														<Disclosure.Panel className="px-4 pt-4 pb-2 text-sm tracking-wide text-gray-900">
															<Markdown
																Output={item}
																ignoreHeadings={true}
																replaceH1={true}
															/>
														</Disclosure.Panel>
													</>
												)}
											</Disclosure>
										);
									}
								})}
							</div>
						</div>
					</div>
				</div>
			</section>
		</>
	);
};

export default WhoWeAre;
